/**
 * @desc Yung-审批前事件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(
  body: defs.basics.ApprovalBeforeRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/beforeEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
